import moment from 'moment-timezone';

export default function formatDate(date, pattern = 'Do MMM, `YY') {
  return moment.utc(date).tz('Asia/Dhaka').format(pattern);
}
